/**
 * Utilidad de impresión - MODO DUAL
 * 
 * ✅ Electron  → webContents.print() via driver Windows (POS-58 Bluetooth)
 * ✅ Navegador → window.print como fallback (móvil/PWA)
 * 
 * ANCHO MÁXIMO: 27 caracteres (verificado en POS-58)
 */

// ========================================
// DETECTAR ENTORNO
// ========================================
const isElectron = (() => {
  if (typeof window === 'undefined') return false
  if (window.electronAPI) return true
  if (window.process && window.process.type === 'renderer') return true
  if (navigator.userAgent && navigator.userAgent.includes('Electron')) return true
  return false
})()

const ANCHO_MAX = 27

// ========================================
// HELPER: fecha ISO → dd/mm/aaaa
// ========================================
function formatFecha(fechaISO) {
  if (!fechaISO) return ''
  const [anio, mes, dia] = fechaISO.split('-')
  return `${dia}/${mes}/${anio}`
}

function formatFechaConDia(fechaISO) {
  if (!fechaISO) return ''
  const dias = ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb']
  const d = new Date(fechaISO + 'T00:00:00')
  return `${dias[d.getDay()]} ${fechaISO.split('-').reverse().join('/')}`
}

// ========================================
// ORDEN DE PRODUCTOS EN TICKET
// ========================================
function ordenProducto(nombre) {
  const n = (nombre || '').toLowerCase()
  if (n.includes('pan grande'))                          return 1
  if (n.includes('pan pequeño') || n.includes('pan peq')) return 2
  if (n.includes('barra')    && !n.includes('media'))    return 3
  if (n.includes('fabiola')  && !n.includes('media'))    return 4
  if (n.includes('integral') && n.includes('grande'))    return 5
  if (n.includes('media')    && n.includes('barra'))     return 6
  if (n.includes('media')    && n.includes('fabiola'))   return 7
  if (n.includes('media')    && n.includes('integral'))  return 8
  if (n.includes('bollo'))                               return 9
  if (n.includes('rosco') && !n.includes('rosquilla'))   return 10
  if (n.includes('hogaza'))                              return 11
  if (n.includes('cruasan') || n.includes('croissant'))  return 12
  if (n.includes('napolitana'))                          return 13
  if (n.includes('magdalena'))                           return 14
  if (n.includes('pan rallado'))                         return 15
  if (n.includes('saco'))                                return 16
  if (n.includes('rosquilla'))                           return 17
  if (n.includes('pasta'))                               return 18
  return 19
}

// ========================================
// GENERADORES DE TICKET
// ========================================

function generarTicketAlbaran(cliente, lineas, productos, fecha, conPrecios = false) {
  const productosMap = new Map(productos.map(p => [p.id, p]))
  // Ordenar lineas por prioridad de producto
  const lineas_ = [...lineas].sort((a, b) => {
    const pa = productosMap.get(a.product_id)
    const pb = productosMap.get(b.product_id)
    const d = ordenProducto(pa?.nombre) - ordenProducto(pb?.nombre)
    return d !== 0 ? d : (pa?.nombre || '').localeCompare(pb?.nombre || '')
  })
  const ticket = []

  ticket.push({ tipo: 'linea_negrita', texto: 'PANADERIA' })
  ticket.push({ tipo: 'linea_negrita', texto: 'HNOS. ALONSO S.L.' })
  ticket.push({ tipo: 'linea',         texto: 'CIF: B34153692' })
  ticket.push({ tipo: 'separador' })

  const nombreCliente = (cliente.alias || cliente.razon_social || '').slice(0, 27)
  ticket.push({ tipo: 'linea_negrita', texto: nombreCliente })
  ticket.push({ tipo: 'linea', texto: 'Fecha:   ' + fecha })
  ticket.push({ tipo: 'separador' })

  if (conPrecios) {
    ticket.push({ tipo: 'linea_negrita', texto: 'Cant  Producto' })
    ticket.push({ tipo: 'separador' })

    let totalGeneral = 0

    for (const linea of lineas_) {
      const producto = productosMap.get(linea.product_id)
      if (!producto) continue

      const cantidad = Number(linea.cantidad_entregada || linea.entregado || 0)
      const devuelto = Number(linea.cantidad_devuelta || linea.devuelto || 0)
      const cantidadNeta = cantidad - devuelto

      if (cantidadNeta > 0) {
        const precio = Number(linea.precio_unit || producto.precio_base || 0)
        const total = precio * cantidadNeta
        totalGeneral += total

        const nombreTruncado = producto.nombre.slice(0, 20)
        const cantStr = String(cantidadNeta).padEnd(3)
        ticket.push({ tipo: 'linea', texto: cantStr + ' ' + nombreTruncado })

        const precioStr = precio.toFixed(2).replace('.', ',')
        const totalStr  = total.toFixed(2).replace('.', ',')
        ticket.push({ tipo: 'linea', texto: '  ' + precioStr + ' x ' + cantidadNeta + ' = ' + totalStr + ' €' })
      }
    }

    ticket.push({ tipo: 'separador' })
    const totalStr = totalGeneral.toFixed(2).replace('.', ',')
    ticket.push({ tipo: 'linea_negrita', texto: 'TOTAL: ' + totalStr + ' €' })

  } else {
    // Layout 25 chars: Uds(3) + sp(1) + Producto(15) + Devol.(6) = 25
    // Deja ~3mm de margen derecho en iOS AirPrint (43mm contenedor - 39.7mm contenido)
    const cabAlbaran = 'Uds' + ' ' + 'Producto'.padEnd(15) + 'Devol.'
    ticket.push({ tipo: 'linea_negrita', texto: cabAlbaran })
    ticket.push({ tipo: 'separador' })

    for (const linea of lineas_) {
      const producto = productosMap.get(linea.product_id)
      if (!producto) continue

      const cantidad = linea.cantidad_entregada || linea.entregado || 0
      const devuelto = linea.cantidad_devuelta || linea.devuelto || 0

      if (cantidad > 0) {
        const cantStr = String(cantidad).padStart(3)
        const nombre  = producto.nombre.slice(0, 15).padEnd(15)
        const devCol  = devuelto > 0 ? ('-' + devuelto).padStart(6) : ''
        ticket.push({ tipo: 'linea', texto: cantStr + ' ' + nombre + devCol })
      }
    }
  }

  ticket.push({ tipo: 'separador' })
  ticket.push({ tipo: 'avance' })
  ticket.push({ tipo: 'corte' })

  return ticket
}

function generarTicketResumenCliente(cliente, resumen, totalConMargen, totalSinMargen, montoMargen, totalFinal, fechaDesde, fechaHasta, formato = '58mm') {
  const ticket = []
  const ANCHO = formato === '58mm' ? 27 : 42
  const TIPO_SEP = formato === '58mm' ? 'separador' : 'separador_largo'

  ticket.push({ tipo: 'linea_negrita', texto: 'PANADERIA' })
  ticket.push({ tipo: 'linea_negrita', texto: 'HNOS. ALONSO S.L.' })
  ticket.push({ tipo: 'linea',         texto: 'NIF: B34153692' })

  const nombreCliente = (cliente.alias || cliente.razon_social || '').slice(0, ANCHO)
  ticket.push({ tipo: 'linea', texto: nombreCliente })
  ticket.push({ tipo: TIPO_SEP })

  ticket.push({ tipo: 'linea', texto: 'COBRO DEL PERIODO' })
  ticket.push({ tipo: 'linea', texto: ('Del: ' + fechaDesde).slice(0, ANCHO) })
  ticket.push({ tipo: 'linea', texto: ('Al:  ' + fechaHasta).slice(0, ANCHO) })
  ticket.push({ tipo: TIPO_SEP })

  const resumenArray = Array.isArray(resumen) ? resumen : Object.values(resumen || {})

  for (const item of resumenArray) {
    const precioUnitario = item.precioUnit 
      || item.precio
      || (item.cantidad > 0 ? item.subtotal / item.cantidad : 0)

    const precioStr = precioUnitario.toFixed(2).replace('.', ',')
    const totalStr  = (item.subtotal || 0).toFixed(2).replace('.', ',')

    // Nombre en negrita y mayúsculas — identifica el producto de un vistazo
    ticket.push({ tipo: 'linea_negrita', texto: (item.nombre || '').toUpperCase().slice(0, ANCHO) })
    // Cálculo en una línea: cant x precio = total
    const calculo = '  ' + item.cantidad + ' x ' + precioStr + ' = ' + totalStr + ' €'
    ticket.push({ tipo: 'linea', texto: calculo.slice(0, ANCHO) })
    // Espacio entre productos
    ticket.push({ tipo: 'linea', texto: '' })
  }

  ticket.push({ tipo: TIPO_SEP })

  if (montoMargen > 0) {
    const porcentaje = cliente.descuento_porcentaje || 0
    const margenValor = montoMargen.toFixed(2).replace('.', ',')
    ticket.push({ tipo: 'linea', texto: ('- Desc ' + porcentaje + '%  -' + margenValor).slice(0, ANCHO) })
    ticket.push({ tipo: TIPO_SEP })
  }

  const totalValorStr = totalFinal.toFixed(2).replace('.', ',')
  ticket.push({ tipo: 'linea_negrita', texto: ('TOTAL: ' + totalValorStr + ' €').slice(0, ANCHO) })
  ticket.push({ tipo: TIPO_SEP })
  ticket.push({ tipo: 'avance' })
  ticket.push({ tipo: 'corte' })

  return ticket
}

function generarTicketFactura(factura, configuracion) {
  const ticket = []
  const ANCHO_FACTURA = 42

  ticket.push({ tipo: 'linea_negrita', texto: 'Factura número:' })
  ticket.push({ tipo: 'linea_titulo', texto: factura.serie + '-' + factura.numero })
  ticket.push({ tipo: 'separador_largo' })
  ticket.push({ tipo: 'linea_negrita', texto: configuracion.nombre_empresa || 'PANADERIA HNOS. ALONSO S.L.' })
  ticket.push({ tipo: 'linea', texto: 'CIF: ' + (configuracion.cif || 'B34153692') })

  if (configuracion.direccion) ticket.push({ tipo: 'linea', texto: configuracion.direccion.slice(0, 42) })
  if (configuracion.cp && configuracion.poblacion) {
    ticket.push({ tipo: 'linea', texto: (configuracion.cp + ' ' + configuracion.poblacion).slice(0, 42) })
  }

  ticket.push({ tipo: 'separador_largo' })
  ticket.push({ tipo: 'linea_negrita', texto: 'CLIENTE:' })
  ticket.push({ tipo: 'linea', texto: factura.cliente_nombre.slice(0, 42) })
  if (factura.cliente_cif) ticket.push({ tipo: 'linea', texto: 'CIF: ' + factura.cliente_cif })
  if (factura.cliente_direccion) ticket.push({ tipo: 'linea', texto: factura.cliente_direccion.slice(0, 42) })

  ticket.push({ tipo: 'separador_largo' })
  ticket.push({ tipo: 'linea', texto: 'Fecha: ' + formatFecha(factura.fecha_emision) })

  if (factura.periodo_inicio && factura.periodo_fin) {
    const inicio = new Date(factura.periodo_inicio).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit' })
    const fin = new Date(factura.periodo_fin).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit' })
    ticket.push({ tipo: 'linea', texto: 'Periodo: ' + inicio + ' - ' + fin })
  }

  ticket.push({ tipo: 'separador_largo' })
  // Layout fijo 42 chars: Cant(4) + sp(1) + Concepto(21) + P/Ud(7) + sp(1) + Base(8) = 42
  const cabecera = 'Cant' + ' ' + 'Concepto'.padEnd(21) + 'P/Ud'.padStart(7) + ' ' + 'Base'.padStart(8)
  ticket.push({ tipo: 'linea_negrita', texto: cabecera })
  ticket.push({ tipo: 'separador_largo' })

  if (factura.lineas && factura.lineas.length > 0) {
    // Agrupar por tipo de IVA para identificar cada tramo visualmente
    const grupos = {}
    for (const linea of factura.lineas) {
      const ivaPct = String(linea.iva_pct ?? 10)
      if (!grupos[ivaPct]) grupos[ivaPct] = []
      grupos[ivaPct].push(linea)
    }
    const ivaRates = Object.keys(grupos).sort((a, b) => Number(b) - Number(a))
    const variosTramos = ivaRates.length > 1

    for (const ivaPct of ivaRates) {
      if (variosTramos) {
        ticket.push({ tipo: 'linea_negrita', texto: ' IVA ' + ivaPct + '%' })
      }
      for (const linea of grupos[ivaPct]) {
        const cant   = String(linea.cantidad || 0).padStart(4)
        const desc   = String(linea.concepto || '').slice(0, 21).padEnd(21)
        const precio = Number(linea.precio_unit || 0).toFixed(2).replace('.', ',').padStart(7)
        const base   = (linea.base || 0).toFixed(2).replace('.', ',').padStart(8)
        ticket.push({ tipo: 'linea', texto: `${cant} ${desc}${precio} ${base}` })
      }
    }
  }

  ticket.push({ tipo: 'separador_largo' })

  const baseStr = 'Base imponible:'
  const baseValor = (factura.base_imponible || 0).toFixed(2).replace('.', ',')
  const espaciosBase = ANCHO_FACTURA - baseStr.length - baseValor.length
  ticket.push({ tipo: 'linea', texto: baseStr + ' '.repeat(Math.max(espaciosBase, 1)) + baseValor })

  if (factura.desglose_iva && factura.desglose_iva.length > 0) {
    for (const desglose of factura.desglose_iva) {
      const ivaTexto = 'IVA ' + desglose.iva_pct + '%:'
      const ivaValor = (desglose.iva || 0).toFixed(2).replace('.', ',')
      const espaciosIva = ANCHO_FACTURA - ivaTexto.length - ivaValor.length
      ticket.push({ tipo: 'linea', texto: ivaTexto + ' '.repeat(Math.max(espaciosIva, 1)) + ivaValor })

      if (desglose.re && desglose.re > 0) {
        const reTexto = 'Rec. Equiv. ' + desglose.re_pct + '%:'
        const reValor = desglose.re.toFixed(2).replace('.', ',')
        const espaciosRe = ANCHO_FACTURA - reTexto.length - reValor.length
        ticket.push({ tipo: 'linea', texto: reTexto + ' '.repeat(Math.max(espaciosRe, 1)) + reValor })
      }
    }
  }

  ticket.push({ tipo: 'separador_corto' })

  const totalValor = (factura.total || 0).toFixed(2).replace('.', ',')
  ticket.push({ tipo: 'linea_total', texto: 'TOTAL: ' + totalValor + ' EUR' })

  ticket.push({ tipo: 'separador_largo' })

  // ── VeriFactu (solo si la factura ya fue enviada a la AEAT) ──
  if (factura.estado_verifactu === 'enviada') {
    ticket.push({ tipo: 'linea_negrita', texto: 'ENVIADA A VERIFACTU - AEAT' })
    if (factura.csv_aeat) {
      const csv = factura.csv_aeat
      for (let i = 0; i < csv.length; i += 42) {
        ticket.push({ tipo: 'linea', texto: csv.slice(i, i + 42) })
      }
    }
    if (factura.qr_aeat && factura.qr_aeat.startsWith('http')) {
      ticket.push({ tipo: 'linea_qr', texto: factura.qr_aeat })
    }
    ticket.push({ tipo: 'separador_largo' })
  }

  ticket.push({ tipo: 'avance' })
  ticket.push({ tipo: 'corte' })

  return ticket
}

function generarTicketResumenSemanal(datosClientes, totales, fechaInicio, fechaFin, configuracion, formato = '80mm') {
  const ticket = []
  const es80 = formato === '80mm'
  const SEP = es80 ? 'separador_largo' : 'separador'

  ticket.push({ tipo: 'linea', texto: 'DE  ' + formatFecha(fechaInicio) })
  ticket.push({ tipo: 'linea', texto: 'AL  ' + formatFecha(fechaFin) })
  ticket.push({ tipo: SEP })

  datosClientes.forEach(cliente => {
    ticket.push({ tipo: 'nombre_semanal', texto: cliente.nombre.toUpperCase() })
    ticket.push({ tipo: 'importe_semanal', texto: cliente.total.toFixed(2).replace('.', ',') })
    ticket.push({ tipo: SEP })
  })

  const fechaImpresion = new Date().toLocaleString('es-ES', {
    day: '2-digit', month: '2-digit', year: '2-digit',
    hour: '2-digit', minute: '2-digit'
  })
  ticket.push({ tipo: 'linea', texto: 'Impreso: ' + fechaImpresion })
  ticket.push({ tipo: 'avance' })
  ticket.push({ tipo: 'corte' })

  return ticket
}

function ticketResumenSemanalAHTML(lineas, ancho80mm = true) {
  const maxWidth = ancho80mm ? '76mm' : '50mm'
  const fontNombre = ancho80mm ? '20px' : '16px'
  const fontImporte = ancho80mm ? '24px' : '20px'
  const fontBase = ancho80mm ? '15px' : '13px'

  const cuerpo = lineas
    .filter(l => l.tipo !== 'avance' && l.tipo !== 'corte')
    .map(l => {
      switch (l.tipo) {
        case 'nombre_semanal':
          return `<span style="font-size:${fontNombre}"><b>${l.texto}</b></span>`
        case 'importe_semanal':
          return `<span style="font-size:${fontImporte}"><b>${l.texto}</b></span>`
        case 'separador':
          return '-'.repeat(24)
        case 'separador_largo':
          return '-'.repeat(35)
        default:
          return l.texto || ''
      }
    })
    .join('\n')

  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <style>
    * { box-sizing: border-box; }
    html, body { margin: 0; padding: 0; background: #fff; }
    @media print { html, body { margin: 0; padding: 0; } }
    pre {
      font-family: 'Courier New', Courier, monospace;
      font-size: ${fontBase};
      line-height: 1.4;
      margin: 2mm 0 0 0;
      padding: 0;
      max-width: ${maxWidth};
      overflow: hidden;
      white-space: pre;
      color: #000;
      background: #fff;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      font-weight: 500;
    }
  </style>
</head>
<body><pre>${cuerpo}</pre></body>
</html>`
}

// ========================================
// CONVERSIÓN: ticket → HTML para impresión
// ========================================

function ticketAHTML(lineas, ancho58mm = true) {
  const pageWidth = ancho58mm ? '58mm' : '80mm'
  // iOS AirPrint ignora @page margin:0 y aplica ~7mm de margen por lado
  // Con papel 58mm quedan ~44mm imprimibles → usamos 43mm para tener 0.5mm de buffer
  // A 10px Courier New: 27 chars × 6px = 162px ≈ 43mm → encaja justo
  const maxWidth = ancho58mm ? '43mm' : '70mm'

  // Usar <pre> con spans para negrita — evita el interlineado extra de los <div>
  const cuerpo = lineas
    .filter(l => l.tipo !== 'avance' && l.tipo !== 'corte')
    .map(l => {
      switch (l.tipo) {
        case 'linea_titulo':
          return `<span style="font-size:13px"><b>${l.texto}</b></span>`
        case 'linea_total':
          return `<span style="font-size:15px"><b>${l.texto}</b></span>`
        case 'linea_negrita':
          return `<b>${l.texto}</b>`
        case 'separador':
          return `${'-'.repeat(25)}`
        case 'separador_largo':
          return `${'='.repeat(42)}`
        case 'separador_corto':
          return `${'-'.repeat(42)}`
        case 'linea_qr':
          return `[QR: ${l.texto}]`
        default:
          return l.texto || ''
      }
    })
    .join('\n')

  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <style>
    @media print {
      @page { size: ${pageWidth} auto; margin: 0mm; }
      html, body { margin: 0 !important; padding: 0 !important; }
    }
    html, body {
      margin: 0;
      padding: 0;
      background: #fff;
      width: 100%;
    }
    body {
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }
    pre {
      font-family: 'Courier New', Courier, monospace;
      font-size: 10px;
      line-height: 1.15;
      letter-spacing: 0;
      margin: 0;
      padding: 0;
      width: ${maxWidth};
      max-width: ${maxWidth};
      overflow: hidden;
      white-space: pre;
      color: #000;
      -webkit-print-color-adjust: exact;
      font-weight: 500;
    }
  </style>
</head>
<body><pre>${cuerpo}</pre></body>
</html>`
}

// ========================================
// IMPRIMIR EN ELECTRON (webContents.print)
// ========================================

async function imprimirEnElectron(lineas, ancho58mm = true) {
  const html = ticketAHTML(lineas, ancho58mm)
  console.log('🖨️ Electron: enviando a webContents.print via IPC')
  const resultado = await window.electronAPI.imprimirFallback({ html })
  if (!resultado.exito) throw new Error(resultado.error || 'Error de impresión')
  return true
}

// ========================================
// IMPRIMIR EN NAVEGADOR (window.print)
// ========================================

function imprimirEnNavegador(lineas, ancho58mm = true) {
  const html = ticketAHTML(lineas, ancho58mm)
  
  return new Promise((resolve, reject) => {
    const ventana = window.open('', '_blank', 'width=400,height=600')
    if (!ventana) { reject(new Error('No se pudo abrir ventana')); return }

    ventana.document.write(html)
    ventana.document.close()

    ventana.onload = () => {
      setTimeout(() => {
        ventana.print()
        setTimeout(() => { ventana.close(); resolve(true) }, 500)
      }, 300)
    }
  })
}

// ========================================
// FUNCIONES PRINCIPALES EXPORTADAS
// ========================================

export async function imprimirAlbaran(cliente, lineas, productos, fecha, conPrecios = false) {
  const ticket = generarTicketAlbaran(cliente, lineas, productos, fecha, conPrecios)
  console.log('🖨️ imprimirAlbaran - Electron:', isElectron)

  if (isElectron) {
    return imprimirEnElectron(ticket, true)
  } else {
    return imprimirEnNavegador(ticket, true)
  }
}

export async function imprimirFactura(factura, configuracion) {
  const ticket = generarTicketFactura(factura, configuracion)
  console.log('🖨️ imprimirFactura - Electron:', isElectron)

  if (isElectron) {
    return imprimirEnElectron(ticket, false) // 80mm
  } else {
    return imprimirEnNavegador(ticket, false)
  }
}

export async function imprimirResumenSemanal(datosClientes, totales, fechaInicio, fechaFin, configuracion, formato = '80mm') {
  const ticket = generarTicketResumenSemanal(datosClientes, totales, fechaInicio, fechaFin, configuracion, formato)
  const ancho80mm = formato === '80mm'
  const html = ticketResumenSemanalAHTML(ticket, ancho80mm)
  console.log('🖨️ imprimirResumenSemanal - Electron:', isElectron)

  if (isElectron) {
    const resultado = await window.electronAPI.imprimirFallback({ html })
    if (!resultado.exito) throw new Error(resultado.error || 'Error de impresión')
    return true
  } else {
    return new Promise((resolve, reject) => {
      const ventana = window.open('', '_blank', 'width=400,height=600')
      if (!ventana) { reject(new Error('No se pudo abrir ventana')); return }
      ventana.document.write(html)
      ventana.document.close()
      ventana.onload = () => {
        setTimeout(() => {
          ventana.print()
          setTimeout(() => { ventana.close(); resolve(true) }, 500)
        }, 300)
      }
    })
  }
}

export async function imprimirResumenCliente(
  cliente, resumen, totalConMargen, totalSinMargen,
  montoMargen, totalFinal, fechaDesde, fechaHasta,
  formato = '58mm'
) {
  const ticket = generarTicketResumenCliente(
    cliente, resumen, totalConMargen, totalSinMargen,
    montoMargen, totalFinal, fechaDesde, fechaHasta, formato
  )
  const es58mm = formato === '58mm'
  console.log('🖨️ imprimirResumenCliente - Electron:', isElectron)

  if (isElectron) {
    return imprimirEnElectron(ticket, es58mm)
  } else {
    return imprimirEnNavegador(ticket, es58mm)
  }
}

export function checkBluetoothSupport() {
  return {
    supported: true,
    message: isElectron 
      ? 'Impresión via driver Windows (POS-58)' 
      : 'Impresión via navegador'
  }
}
